import api from "../../api";

const state = {
  projectUrl: null,
  projectId: null,
  stage: "",
  title: "",
  description: "",
  skills: [],
  talent_size: 1,
  specifications: [],
  specificationImg: "",
  jobType: "",
  location: "",
  devSkills: [],
  duration: 1,
  commitment: 1,
  complexity: 1,
  start_budget: 20,
  end_budget: 50,
  projects: [],
};

const getters = {
  projectId: (state) => {
    const url = state.projectUrl.split("/");
    return url[url.length - 1];
  },
};

const mutations = {
  set_projectUrl(state, data) {
    state.projectUrl = data.projectUrl;
  },
};

const actions = {
  browseProject({ commit, rootGetters }, data) {
    return new Promise((resolve, reject) => {
      commit("make_request", null, { root: true });
      api({
        url: `projects/search?offset=${data.offset}&limit=${data.limit}`,
        method: "POST",
        data: data.filters,
        withCredentials: true,
        headers: {
          Authorization: rootGetters.authToken,
        },
      })
        .then((resp) => {
          commit("request_success", null, { root: true });
          resolve(resp);
        })
        .catch((err) => {
          commit("request_error", null, { root: true });
          reject(err);
        });
    });
  },

  postProject({ commit, rootGetters }) {
    const projectData = {
      title: state.title,
      description: state.description,
      talent_size: Number(state.talent_size),
      skills: state.skills,
      duration: Number(state.duration),
      commitment: Number(state.commitment),
      complexity: Number(state.complexity),
      start_budget: Number(state.start_budget),
      end_budget: Number(state.end_budget),
      // title: "JB Finance project",
      // description: "A Fintech project that connect banks to logistic company",
      // talent_size: 5,
      // skills: ["Reactjs", "Nodejs", "Grpc", "Protobuf"],
      // duration: 4,
      // commitment: 2,
      // complexity: 1,
      // start_budget: 3000,
      // end_budget: 5000,
    };

    console.log("projectData", projectData);

    return new Promise((resolve, reject) => {
      commit("make_request", null, { root: true });
      api({
        url: `projects`,
        method: "POST",
        withCredentials: true,
        data: projectData,
        headers: {
          Authorization: rootGetters.authToken,
        },
      })
        .then((resp) => {
          commit("request_success", null, { root: true });
          resolve(resp);
        })
        .catch((err) => {
          commit("request_error", null, { root: true });
          reject(err);
        });
    });
  },

  getProject({ commit, rootGetters }, data) {
    return new Promise((resolve, reject) => {
      commit("make_request", null, { root: true });
      api({
        url: `projects/${data.projectId}`,
        method: "GET",
        withCredentials: true,
        headers: {
          Authorization: rootGetters.authToken,
        },
      })
        .then((resp) => {
          commit("request_success", null, { root: true });
          resolve(resp);
        })
        .catch((err) => {
          commit("request_error", null, { root: true });
          reject(err);
        });
    });
  },

  updateProject({ commit, getters, rootGetters }, user) {
    return new Promise((resolve, reject) => {
      commit("make_request", null, { root: true });
      api({
        url: `projects/${getters.projectId}`,
        method: "PUT",
        withCredentials: true,
        data: user.data,
        headers: {
          Authorization: rootGetters.authToken,
        },
      })
        .then((resp) => {
          commit("request_success", null, { root: true });
          resolve(resp);
        })
        .catch((err) => {
          commit("request_error", null, { root: true });
          reject(err);
        });
    });
  },

  updateProjectStatus({ commit, getters, rootGetters }, data) {
    return new Promise((resolve, reject) => {
      commit("make_request", null, { root: true });
      api({
        url: `projects/status/${getters.projectId}?status=${data.status}`,
        method: "PUT",
        withCredentials: true,
        headers: {
          Authorization: rootGetters.authToken,
        },
      })
        .then((resp) => {
          commit("request_success", null, { root: true });
          resolve(resp);
        })
        .catch((err) => {
          commit("request_error", null, { root: true });
          reject(err);
        });
    });
  },

  deleteProject({ commit, getters, rootGetters }) {
    return new Promise((resolve, reject) => {
      commit("make_request", null, { root: true });
      api({
        url: `projects/${getters.projectId}`,
        method: "DELETE",
        withCredentials: true,
        headers: {
          Authorization: rootGetters.authToken,
        },
      })
        .then((resp) => {
          commit("request_success", null, { root: true });
          resolve(resp);
        })
        .catch((err) => {
          commit("request_error", null, { root: true });
          reject(err);
        });
    });
  },

  getProjects({ commit, rootGetters, state }, data) {
    return new Promise((resolve, reject) => {
      commit("make_request", null, { root: true });
      api({
        url: `projects?offset=${data.offset}&limit=${data.limit}`,
        method: "GET",
        withCredentials: true,
        headers: {
          Authorization: rootGetters.authToken,
        },
      })
        .then((resp) => {
          commit("request_success", null, { root: true });
          state.project = resp.data;
          resolve(resp);
        })
        .catch((err) => {
          commit("request_error", null, { root: true });
          reject(err);
        });
    });
  },
};

export const projects = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
